import routes from './routes';
import { SetRoutes } from 'components';

const CompaniesPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default CompaniesPages;
